import { render, staticRenderFns } from "./MJFooter.vue?vue&type=template&id=76ea561c&scoped=true&"
import script from "./MJFooter.vue?vue&type=script&lang=js&"
export * from "./MJFooter.vue?vue&type=script&lang=js&"
import style0 from "./MJFooter.vue?vue&type=style&index=0&id=76ea561c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ea561c",
  null
  
)

export default component.exports